import(/* webpackMode: "eager", webpackExports: ["BankView"] */ "/app/src/sections/presentation/bank/bank-view.tsx");
